<div class="nb-card">
    <div fxLayout="row">
        <div class="nb-card-icon" fxFlex="20" fxLayoutGap="0.5rem">
            <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
            <span>{{netzbetreiber.stadtwerkeId}}</span>
        </div>
        <div fxLayout="column">
            <div fxFlex="40">{{netzbetreiber.name}}</div>
            <div fxFlex="40">{{netzbetreiber.teilgebiet}}</div>
            <div fxLayout="column">
            </div>
        </div>
    </div>
</div>
